import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://api.symmatrimonial.com/api';

class PlanService {
  constructor() {
    this.api = axios.create({
      baseURL: `${API_BASE_URL}/plans`,
    });

    // Add token to requests
    this.api.interceptors.request.use((config) => {
      const token = localStorage.getItem('adminToken');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    });
  }

  // Get all plans
  async getAllPlans(activeOnly = false) {
    const response = await this.api.get('/', {
      params: activeOnly ? { active_only: 'true' } : {}
    });
    return response.data;
  }

  // Get plan by ID
  async getPlanById(id) {
    const response = await this.api.get(`/${id}`);
    return response.data;
  }

  // Create new plan
  async createPlan(planData) {
    const response = await this.api.post('/', planData);
    return response.data;
  }

  // Update plan
  async updatePlan(id, planData) {
    const response = await this.api.put(`/${id}`, planData);
    return response.data;
  }

  // Delete plan
  async deletePlan(id) {
    const response = await this.api.delete(`/${id}`);
    return response.data;
  }

  // Toggle plan status
  async togglePlanStatus(id) {
    const response = await this.api.patch(`/${id}/toggle-status`);
    return response.data;
  }

  // Get plan statistics
  async getPlanStats() {
    const response = await this.api.get('/stats');
    return response.data;
  }

  // Get plans by price range
  async getPlansByPriceRange(minPrice, maxPrice) {
    const response = await this.api.get('/price-range', {
      params: { min_price: minPrice, max_price: maxPrice }
    });
    return response.data;
  }

  // Get plans by duration
  async getPlansByDuration(durationDays) {
    const response = await this.api.get('/duration', {
      params: { duration_days: durationDays }
    });
    return response.data;
  }
}

export default new PlanService();
